import React, { useEffect, useMemo, useState } from 'react';
import V4Tabs from './V4Tabs';
import { API_BASE_URL } from '../../config';
import { useAuth } from '../../contexts/AuthContext';
import ReactMarkdown from 'react-markdown';

const DocumentsChatLogsV4 = () => {
  const { getAuthHeaders } = useAuth();
  const headers = useMemo(() => ({ ...getAuthHeaders() }), [getAuthHeaders]);
  const [q, setQ] = useState('');
  const [status, setStatus] = useState('');
  const [isVoice, setIsVoice] = useState('');
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [limit] = useState(25);
  const [offset, setOffset] = useState(0);
  const [view, setView] = useState(null); // { id, loading, data }

  const load = async () => {
    const params = new URLSearchParams();
    if (q) params.set('q', q);
    if (status) params.set('status', status);
    if (isVoice !== '') params.set('is_voice', String(isVoice === 'true'));
    params.set('limit', String(limit));
    params.set('offset', String(offset));
    const res = await fetch(`${API_BASE_URL}/api/v4/documents/assistant/logs?${params.toString()}`, { headers });
    const data = await res.json();
    setItems(Array.isArray(data.items) ? data.items : []);
    setTotal(data.total || 0);
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [offset]);

  const openFull = async (id) => {
    setView({ id, loading: true, data: null });
    try {
      const res = await fetch(`${API_BASE_URL}/api/v4/documents/assistant/logs/${id}`, { headers });
      const data = await res.json();
      setView({ id, loading: false, data });
    } catch (e) {
      setView({ id, loading: false, data: { error: String(e) } });
    }
  };
  const closeFull = () => setView(null);

  return (
    <div className="container py-4">
      <h3 className="mb-3">Documents v4</h3>
      <V4Tabs />
      <div className="card">
        <div className="card-body">
          <div className="row g-2 mb-3">
            <div className="col-md-4"><input className="form-control" placeholder="Search question/answer" value={q} onChange={(e)=>setQ(e.target.value)} /></div>
            <div className="col-md-3">
              <select className="form-select" value={status} onChange={(e)=>setStatus(e.target.value)}>
                <option value="">All statuses</option>
                <option value="answered">Answered</option>
                <option value="unanswered">Unanswered</option>
                <option value="failed">Failed</option>
              </select>
            </div>
            <div className="col-md-3">
              <select className="form-select" value={isVoice} onChange={(e)=>setIsVoice(e.target.value)}>
                <option value="">All input types</option>
                <option value="true">Voice</option>
                <option value="false">Text</option>
              </select>
            </div>
            <div className="col-md-2"><button className="btn btn-primary w-100" onClick={()=>{ setOffset(0); load(); }}>Search</button></div>
          </div>
          <div className="table-responsive">
            <table className="table table-sm align-middle">
              <thead>
                <tr>
                  <th>When</th>
                  <th>Status</th>
                  <th>Voice</th>
                  <th>Response ms</th>
                  <th>Question</th>
                  <th>Answer (preview)</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {(items || []).map((r) => (
                  <tr key={r.id}>
                    <td className="text-nowrap">{new Date(r.started_at).toLocaleString()}</td>
                    <td>{r.status}</td>
                    <td>{r.is_voice ? 'Yes' : 'No'}</td>
                    <td>{r.response_ms ?? ''}</td>
                    <td style={{maxWidth: 280}}><div className="text-truncate" title={r.question}>{r.question}</div></td>
                    <td style={{maxWidth: 360}}><div className="text-truncate" title={r.answer}>{r.answer}</div></td>
                    <td className="text-end"><button className="btn btn-sm btn-outline-primary" onClick={()=>openFull(r.id)}>View</button></td>
                  </tr>
                ))}
                {(!items || items.length === 0) && (
                  <tr><td colSpan={7} className="text-muted">No results</td></tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-between align-items-center mt-2">
            <button className="btn btn-outline-secondary btn-sm" disabled={offset===0} onClick={()=>setOffset(Math.max(0, offset - limit))}>Prev</button>
            <div className="small text-muted">{offset + 1}-{Math.min(offset + limit, total)} / {total}</div>
            <button className="btn btn-outline-secondary btn-sm" disabled={(offset + limit) >= total} onClick={()=>setOffset(offset + limit)}>Next</button>
          </div>
        </div>
      </div>

      {view && (
        <div className="offcanvas offcanvas-end show" tabIndex="-1" style={{visibility:'visible', width:'50%'}}>
          <div className="offcanvas-header">
            <h5 className="offcanvas-title">Chat Response #{view.id}</h5>
            <button type="button" className="btn-close text-reset" onClick={closeFull}></button>
          </div>
          <div className="offcanvas-body" style={{overflow:'auto'}}>
            {view.loading && <div className="text-muted">Loading…</div>}
            {!view.loading && view.data && (
              <div>
                <div className="mb-3"><strong>Question:</strong><div>{view.data.question}</div></div>
                <div className="mb-3"><strong>Answer:</strong>
                  <div className="border rounded p-2">
                    <ReactMarkdown>{view.data.answer || ''}</ReactMarkdown>
                  </div>
                </div>
                <div className="mb-2 small text-muted">Status: {view.data.status} • Voice: {view.data.is_voice ? 'Yes' : 'No'} • {view.data.response_ms} ms</div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DocumentsChatLogsV4;


